module.exports = __webpack_public_path__ + "static/media/1POLICY3.a01b6e7d.jpg";